<template>
  <a-layout class="bg-main">
    <LeftSider :theme="settings.navTheme" :width="256" :title="settings.title" :menuList="menuList"></LeftSider>
    <a-layout>
      <SideHeader></SideHeader>
      <a-layout>
        <multiTab v-if="multiTabList" @reflesh="refleshPage" :isReflesh="refreshLoading"></multiTab>
        <a-layout style="padding: 0 24px 24px">
          <a-breadcrumb style="margin: 16px 0">
            <template v-for="item in breadCrumbList">
              <a-breadcrumb-item>
                <span style="color: #000000;">{{showBreadcrumbItem(item)}}</span>
              </a-breadcrumb-item>
            </template>
          </a-breadcrumb>
          <a-layout-content :style="{ background: '#fff', minHeight: '280px' }">
            <!-- <router-view /> -->
            <keep-alive :include="multiTabNameList">
              <!-- <router-view v-if="$route.meta.keepAlive" /> -->
              <router-view v-if="refreshControl" ref="child"/>
            </keep-alive>
            <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
  import {
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  import settings from '../../config/defaultSettings.js';
  import leftSider from './leftSider.vue';
  import sideHeader from './sideHeader.vue';
  import multiTab from './multiTab.vue';
  import {
    getUser
  } from '@/api/login.api';
  export default {
    components: {
      'LeftSider': leftSider,
      'SideHeader': sideHeader,
      'multiTab': multiTab
    },
    data() {
      return {
        settings,
        collapsed: false,
        refreshControl: true,
        refreshLoading: false,
        tabNameList: []
      }
    },
    methods: {
      ...mapActions([
        'addOneTabPage',
        'closeOneTabPage',
        'closeAllTabPage',
        'setUserLanguage',
        'removeTab',
        'addTab'
      ]),
      ...mapMutations({
        setBreadCrumb: 'SETBREADCRUMB'
      }),
      refleshPage(name) {
        console.log('refleshPage(name)', name);
        let list = JSON.parse(JSON.stringify(this.multiTabNameList));
        for(let i = 0; i < list.length; i++) {
          let pageName = list[i];
          if(name === pageName) {
            let pageNames = list.splice(i, 1);
            this.removeTab(i);
            this.refreshControl = false;
            this.refreshLoading = true;
            this.$nextTick(() => {
              this.refreshControl = true;
              this.refreshLoading = false;
              this.addTab({pageNames: pageNames[0], idx: i});
            })
            break;
          }
        }
      },
      handleLanguageChange(e) {
        this.$i18n.locale = e.key
        localStorage.setItem('lang', e.key)
        this.setUserLanguage({
          userLang: e.key
        })
      },
      showBreadcrumbItem(item) {
        return item.CNname || item.permissionCode;
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler: function(newRoute) {
          console.log('watch $route', newRoute)
          this.setBreadCrumb({
            list: this.menuList,
            route: newRoute
          });
          this.addOneTabPage({page: newRoute, $router: this.$router});
        },
        deep:true,
      },
    },
    computed: {
      ...mapGetters(["menuList", "userInfo", "breadCrumbList", "multiTabList", "multiTabNameList"]),
    },
    updated() {},
    async mounted() {
      await getUser().then(res=>{
        console.log(res);
      })
    }
  }
</script>
<style scoped lang="less">
  .bg-main {
    min-height: calc(100vh);
  }
  .ant-form-item {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/main.vue